export default __webpack_public_path__ + "static/media/ic_download.f4abba89.svg";